import { Transformer } from '@/src/utils/transformers'
import { SyntaxKind } from 'ts-morph'

const DEFAULT_TAILWIND_CSS_VARIABLE_CONFIG = {
  colors: {
    border: "hsl(var(--border))",
    input: "hsl(var(--input))",
    ring: "hsl(var(--ring))",
    background: "hsl(var(--background))",
    foreground: "hsl(var(--foreground))",
    primary: {
      DEFAULT: "hsl(var(--primary))",
      foreground: "hsl(var(--primary-foreground))",
    },
    secondary: {
      DEFAULT: "hsl(var(--secondary))",
      foreground: "hsl(var(--secondary-foreground))",
    },
    destructive: {
      DEFAULT: "hsl(var(--destructive))",
      foreground: "hsl(var(--destructive-foreground))",
    },
    muted: {
      DEFAULT: "hsl(var(--muted))",
      foreground: "hsl(var(--muted-foreground))",
    },
    accent: {
      DEFAULT: "hsl(var(--accent))",
      foreground: "hsl(var(--accent-foreground))",
    },
    popover: {
      DEFAULT: "hsl(var(--popover))",
      foreground: "hsl(var(--popover-foreground))",
    },
    card: {
      DEFAULT: "hsl(var(--card))",
      foreground: "hsl(var(--card-foreground))",
    },
  },
  borderRadius: {
    lg: "var(--radius)",
    md: "calc(var(--radius) - 2px)",
    sm: "calc(var(--radius) - 4px)",
  },
  keyframes: {
    "accordion-down": {
      from: { height: "0" },
      to: { height: "var(--radix-accordion-content-height)" },
    },
    "accordion-up": {
      from: { height: "var(--radix-accordion-content-height)" },
      to: { height: "0" },
    },
  },
}

/**
 * 
 * @throws property-exists
 */
export const transformTailwindConfig: Transformer = async ({
  sourceFile,
  config,
}) => {
  // Find the ObjectLiteralExpression that contains the tailwind config.
  const tailwindConfig = sourceFile.getFirstDescendantByKind(
    SyntaxKind.ObjectLiteralExpression
  )

  // Find the `plugins` property.
  const pluginsProperty = tailwindConfig?.getProperty('plugins')
  if (pluginsProperty) {
    const pluginsArray = pluginsProperty.getFirstDescendantByKind(
      SyntaxKind.ArrayLiteralExpression
    )

    // Append the `tailwindcss-animate` plugin.
    pluginsArray?.addElement('require("tailwindcss-animate")')

  }

  // Find the theme.extend property and merge colors, borderRAdius, and keyframes with the above DEFAULT_TAILWIND_CSS_VARIABLE_CONFIG
  let themeExtendProperty = tailwindConfig?.getProperty('theme')

  if (!themeExtendProperty) {
    themeExtendProperty = tailwindConfig?.addPropertyAssignment({
      name: 'theme',
      initializer: '{}',
    })
  }

  const themeExtendObject = themeExtendProperty!.getFirstDescendantByKind(
    SyntaxKind.ObjectLiteralExpression
  )

  for (const [key, value] of Object.entries(DEFAULT_TAILWIND_CSS_VARIABLE_CONFIG)) {
    const property = themeExtendObject?.getProperty(key)

    if (!property) {
      themeExtendObject?.addPropertyAssignment({
        name: key,
        initializer: JSON.stringify(value, null, 2),
      })
    } else {
      throw new Error("property-exists")
    }
  }

  return sourceFile
}
